import { useEffect, useState } from "react";
import { CARD, CARD2, BD, TX, TX2, GR, BL, YL, RD, PU } from "../../utils/constants";
import { scoreColor, gradeLabel, biasColor, fmt } from "../../utils/formatUtils";

function SubBar({ label, value, color }) {
  return (
    <div style={{ marginBottom: 5 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
        <span style={{ fontSize: 8, color: TX2, letterSpacing: 1 }}>{label}</span>
        <span style={{ fontSize: 8, fontWeight: 700, color }}>{value}</span>
      </div>
      <div style={{ height: 3, background: CARD2, borderRadius: 2 }}>
        <div style={{ height: "100%", width: `${value}%`, background: color, borderRadius: 2, transition: "width 0.4s" }} />
      </div>
    </div>
  );
}

function useCountUp(target, duration = 600) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration]);
  return count;
}

export default function StockCard({ stock, rank, isWatchlisted, onToggleWL, onStockClick }) {
  const rr = stock.riskReward;
  const displayScore = useCountUp(stock.score, 500);

  return (
    <div className="card-h ts-panel" onClick={() => onStockClick(stock)}
      style={{ background: CARD, border: `1px solid ${rank === 1 ? GR + "35" : BD}`, borderLeft: `3px solid ${scoreColor(stock.score)}`, borderRadius: 10, padding: "11px 14px", marginBottom: 7, boxShadow: rank === 1 ? `0 0 20px ${GR}06` : "none" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>

        <div style={{ minWidth: 100 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
            <span style={{ fontSize: 9, color: rank === 1 ? GR : TX2, fontWeight: 700 }}>#{rank}</span>
            <span style={{ fontSize: 14, fontWeight: 700, fontFamily: "'Space Grotesk',sans-serif", color: TX }}>{stock.symbol}</span>
            {stock.isFMP     && <span style={{ fontSize: 7, background: BL  + "20", color: BL,  border: `1px solid ${BL}40`,  borderRadius: 3, padding: "1px 4px" }}>FMP</span>}
            {stock.isDynamic && <span style={{ fontSize: 7, background: YL + "15", color: YL, border: `1px solid ${YL}30`, borderRadius: 3, padding: "1px 4px" }}>MOVER</span>}
            <span className="star" onClick={(e) => { e.stopPropagation(); onToggleWL(stock.symbol); }} style={{ fontSize: 11, color: isWatchlisted ? YL : TX2 }}>{isWatchlisted ? "★" : "☆"}</span>
          </div>
          <div style={{ fontSize: 8, color: TX2, marginBottom: 3 }}>{stock.sector}</div>
          <div style={{ fontSize: 11, color: TX }}>${stock.price?.toFixed(2)} <span style={{ color: stock.change >= 0 ? GR : RD, fontWeight: 600 }}>{fmt(stock.change || 0)}</span></div>
          {stock.fiveDayReturn != null && <div style={{ fontSize: 8, color: TX2, marginTop: 1 }}>5d: <span style={{ color: stock.fiveDayReturn >= 0 ? GR : RD }}>{stock.fiveDayReturn >= 0 ? "+" : ""}{stock.fiveDayReturn.toFixed(1)}%</span></div>}
        </div>

        <div style={{ minWidth: 148 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 7 }}>
            <span style={{ fontSize: 22, fontWeight: 800, color: scoreColor(stock.score), fontFamily: "'Space Grotesk',sans-serif", lineHeight: 1, minWidth: 34, display: "inline-block" }}>{displayScore}</span>
            <div>
              <div style={{ fontSize: 8, fontWeight: 700, color: scoreColor(stock.score), letterSpacing: 1 }}>{gradeLabel(stock.score)}</div>
              <div style={{ fontSize: 8, color: biasColor(stock.tomorrowBias) }}>tmrw: {stock.tomorrowBias}</div>
            </div>
          </div>
          <SubBar label="MOMENTUM" value={stock.momentum}    color={PU} />
          <SubBar label="POSITION"  value={stock.volumeScore} color={BL} />
          <SubBar label="TREND"     value={stock.trend}       color={GR} />
        </div>

        {rr && (
          <div style={{ background: CARD2, borderRadius: 7, padding: "8px 11px", minWidth: 108 }}>
            <div style={{ fontSize: 7, color: TX2, letterSpacing: 1, marginBottom: 4 }}>RISK / REWARD</div>
            <div style={{ fontSize: 8, color: TX2, marginBottom: 2 }}>Entry  <span style={{ color: TX }}>${rr.entry?.toFixed(2)}</span></div>
            <div style={{ fontSize: 8, color: TX2, marginBottom: 2 }}>Stop   <span style={{ color: RD }}>${rr.stopLoss?.toFixed(2)}</span></div>
            <div style={{ fontSize: 8, color: TX2 }}>Target <span style={{ color: GR }}>${rr.target?.toFixed(2)}</span></div>
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 4, justifyContent: "center" }}>
          <a href={`https://finance.yahoo.com/quote/${stock.symbol}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} style={{ background: CARD2, border: `1px solid ${BD}`, borderRadius: 4, padding: "3px 7px", color: BL, fontSize: 8, textDecoration: "none" }}>Yahoo</a>
          <a href={`https://www.tradingview.com/chart/?symbol=${stock.symbol}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} style={{ background: CARD2, border: `1px solid ${BD}`, borderRadius: 4, padding: "3px 7px", color: GR, fontSize: 8, textDecoration: "none" }}>Chart</a>
        </div>
      </div>
    </div>
  );
}
